import { render } from "./NewDistributorView.vue?vue&type=template&id=29ca274b"
import script from "./NewDistributorView.vue?vue&type=script&lang=js"
export * from "./NewDistributorView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__